// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip--tooltip--A71fQ","label":"Tooltip--label--tVUan","arrow":"Tooltip--arrow--KftPM"};